import type { ResultadoPeso } from './tipos'

export * from './tipos'

const PASTA = '/Sischef/Balanca'
const ARQ_SOLICITACAO = 'lepeso'
const ARQ_RETORNO = 'resp.json'
const PESO_MINIMO_KG = 0.01
const ESPERA_PRIMEIRA_LEITURA_MS = 100
const MAX_TENTATIVAS_LEITURA = 5
const INTERVALO_TENTATIVA_MS = 200

interface RetornoLepeso {
  status: 'SUCCESS' | 'AWAIT' | string;
  value: number;
  message?: string;
}

const espera = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));

export function estaNoElectron(): boolean {
  return !!window.pdvDesktop;
}

export function balancaDisponivel(): boolean {
  return typeof window.pdvDesktop?.createFile === 'function' && typeof window.pdvDesktop?.readFileContent === 'function'
}

export async function getPeso(): Promise<ResultadoPeso> {
  if (!balancaDisponivel()) {
    return {
      status: 'ERRO',
      code: 10,
      message: 'A balança só funciona no app do totem para Windows.',
    };
  }

  return getPesoReal();
}

export async function abrirSischefLepeso(): Promise<void> {
  try {
    await window.pdvDesktop?.openSischefLepeso();
  } catch { }
}

let lepesoIniciado = false;

export async function iniciarLePesoBackground(): Promise<void> {
  if (lepesoIniciado) return;
  lepesoIniciado = true;
  try {
    await window.pdvDesktop?.startSischefLepesoBackground?.();
  } catch { }
}

async function getPesoReal(): Promise<ResultadoPeso> {
  const pdv = window.pdvDesktop!

  try {
    await Promise.all([
      pdv.deleteFile(PASTA, ARQ_SOLICITACAO).catch(() => undefined),
      pdv.deleteFile(PASTA, ARQ_RETORNO).catch(() => undefined),
    ]);
    await pdv.createFile(PASTA, ARQ_SOLICITACAO, 'Solicitacao de peso');
  } catch {
    return { status: 'ERRO', code: 20, message: 'Falha ao solicitar o peso à balança.' };
  }

  for (let tentativa = 0; tentativa < MAX_TENTATIVAS_LEITURA; tentativa++) {
    await espera(tentativa === 0 ? ESPERA_PRIMEIRA_LEITURA_MS : INTERVALO_TENTATIVA_MS);

    let conteudo: string;
    try {
      conteudo = await pdv.readFileContent(PASTA, ARQ_RETORNO, 'utf8');
    } catch {
      continue;
    }
    if (!conteudo) continue;

    let retorno: RetornoLepeso;
    try {
      retorno = JSON.parse(conteudo) as RetornoLepeso;
    } catch {
      continue;
    }

    if (retorno.status === 'SUCCESS') {
      return retorno.value < PESO_MINIMO_KG
        ? { status: 'VAZIO' }
        : { status: 'PESO', pesoKg: retorno.value };
    }
    if (retorno.status === 'AWAIT') {
      return { status: 'INSTAVEL', pesoKg: retorno.value };
    }
    return {
      status: 'ERRO',
      code: retorno.value,
      message: retorno.message ?? 'Não foi possível ler o peso na balança.',
    };
  }

  return {
    status: 'ERRO',
    code: 15,
    message: "Sem resposta da balança. Verifique se o 'Sischef Le Peso' está aberto.",
  };
}
